<h2>Import registrations from excel file</h2>

<p>Use available template to create an excel spreadsheet with list of registrations to import</p>

<a class="template-download space" mat-raised-button color="primary" href="resources/MassRegistration_Template.xlsx">Download
    Excel template</a>
<input #csvInput hidden="true" type="file" onclick="this.value=null" (change)="fileInputChange($event)"
    accept=".xlsx" />
<button class="space" mat-raised-button color="primary" (click)="csvInput.click()">Upload file</button>
<strong>{{fileName}}</strong>

<!-- For debug -->
<!-- {{uploadResponse | json}} -->
<hr/>

<loading-bar *ngIf="validationInProgress" label="Validating file"/>

<div *ngIf="errors.length>0">
    <h4>File not valid:</h4>
    <ul>
        <li *ngFor="let error of errors">{{ error }}</li>
    </ul>
</div>

<button *ngIf="canUpload" mat-raised-button color="primary" (click)="executeUpload()">Execute upload</button>

<loading-bar *ngIf="uploadInProgress" label="Uploading file"/>

<strong *ngIf="uploadFinished">Upload finished</strong>